import { render, staticRenderFns } from "./u-lnb-all-white.vue?vue&type=template&id=2ecfbed4&scoped=true&"
import script from "./u-lnb-all-white.vue?vue&type=script&lang=js&"
export * from "./u-lnb-all-white.vue?vue&type=script&lang=js&"
import style0 from "./u-lnb-all-white.vue?vue&type=style&index=0&id=2ecfbed4&prod&lang=scss&"
import style1 from "./u-lnb-all-white.vue?vue&type=style&index=1&id=2ecfbed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecfbed4",
  null
  
)

export default component.exports